export const downloadByLinkCreation = (href: string, download: string) => {
  const a = document.createElement('a');
  a.href = href;
  a.download = download;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
